<script>
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    accountGroups: {
      type: Array,
      required: true,
    },
    classification: {
      type: Number,
      required: true,
    },
    fundClassifications: {
      type: Array,
      required: true,
    },
    allAccountGroups: {
      type: Array,
      required: true,
    },
    selected: {},
  },
  data() {
    return {
      accountGroup: {
        id: 0,
        groupName: null,
        fundClassificationId: this.classification,
        rcaCode: null,
        accountType: this.selected.className,
      },
      account: {
        id: 0,
        uacs: null,
        accountName: null,
        uacsSubCode: null,
        coveringPpsas: null,
        accountGroupId: null,
        showInDisbursement: false,
      },
      fundClassificationModified: [],
      accountGroupsModified: [],
      modalOptions: {
        title: "",
        show: false,
      },
      modalAccountOptions: {
        title: "",
        show: false,
      },
      accountTypeOptions: [
        "Expenses",
        "Asset",
        "Liabilities",
        "Equity",
        "Revenue/Income",
      ],
      submitted: false,
    };
  },
  watch: {
    selected() {
      this.accountGroup.accountType = this.selected.className;
    },
  },
  created() {
    this.processFC();
    this.processAG();
  },
  methods: {
    processFC() {
      if (this.fundClassifications) {
        this.fundClassificationModified = this.fundClassifications.map(
          (item) => ({
            value: item.id,
            text: item.classification,
          })
        );
      }
    },
    processAG() {
      if (this.allAccountGroups) {
        this.accountGroupsModified = this.allAccountGroups.map((item) => ({
          value: item.id,
          text: item.groupName,
        }));
      }
    },
    addAG() {
      this.onReset();
      this.modalOptions.title = "Add New Account Group";
      this.modalOptions.show = true;
    },
    closeAdd() {
      this.onReset();
      this.modalOptions.show = false;
      this.modalOptions.title = "";
    },
    updateItem(item) {
      this.accountGroup = JSON.parse(JSON.stringify(item));
      this.modalOptions.title = "Update Account Group";
      this.modalOptions.show = true;
    },
    deleteItem(item) {
      this.tableBusy = true;
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("accountgroups/deleteAccountGroup", item.id)
            .then(() => {
              //   this.fetchData(); emit event to refresh table
              this.$emit("fetchAccountGroups", {
                item: { id: this.accountGroup.fundClassificationId },
              });

              this.tableBusy = false;
              this.showToast("Account Group successfully deleted.", "success");
            })
            .catch(() => {
              this.tableBusy = false;
              this.showToast(
                "Cannot delete account group. Please contact your administrator",
                "error"
              );
            });
        }
      });
    },
    onSubmit() {
      this.tableBusy = true;
      this.submitted = true;
      this.$v.accountGroup.$touch();
      if (this.$v.accountGroup.$invalid) {
        return;
      } else {
        // this.accountGroup.fundClassificationId = this.selectedFC;

        if (this.accountGroup.id === 0) {
          // console.log(this.accountGroup);
          /** Add new Record */
          this.$store
            .dispatch("accountgroups/createAccountGroup", this.accountGroup)
            .then((response) => {
              this.$emit("fetchAccountGroups", {
                item: {
                  id: this.accountGroup.fundClassificationId,
                },
              });

              this.showToast("Account Group successfully added.", "success");
              this.onReset();
              this.closeAdd();
              //   this.fetchData(); emit event to refresh data

              this.modalOptions.title = "";
              this.modalOptions.show = false;
              this.tableBusy = false;
              this.submitted = false;
            });
          //   console.log(this.accountGroup);
        } else {
          /** Update Record */
          this.$store
            .dispatch("accountgroups/updateAccountGroup", {
              id: this.accountGroup.id,
              data: this.accountGroup,
            })
            .then((response) => {
              // console.log(response);
              this.$emit("fetchAccountGroups", {
                item: {
                  id: this.accountGroup.fundClassificationId,
                },
              });

              this.showToast("Account Group successfully updated.", "success");
              this.onReset();
              this.closeAdd();
              //   this.fetchData(); emit event to refresh data

              this.modalOptions.title = "";
              this.modalOptions.show = false;
              this.tableBusy = false;
              this.submitted = false;
            })
            .catch(() => {
              this.showToast(
                "Something went wrong. Account Group cannot be deleted.",
                "error"
              );
            });
        }
      }
    },
    onReset() {
      this.accountGroup = {
        id: 0,
        groupName: null,
        fundClassificationId: this.classification,
        rcaCode: null,
        accountType: this.selected.className,
      };
    },
    addAccount(group) {
      this.onAccountReset();
      this.processAG();
      this.account.accountGroupId = group.id;
      this.modalAccountOptions.title = "Add New Account";
      this.modalAccountOptions.show = true;
    },
    closeAddAccount() {
      this.onAccountReset();
      this.modalAccountOptions.show = false;
      this.modalAccountOptions.title = "";
    },
    updateItemAccount(item) {
      this.account = JSON.parse(JSON.stringify(item));
      this.modalAccountOptions.title = "Update Account";
      this.modalAccountOptions.show = true;
    },
    deleteItemAccount(item) {
      this.tableBusy = true;
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store
              .dispatch("accounts/deleteAccount", item.id)
              .then(() => {
                this.$emit("fetchAccounts", {
                  id: item.accountGroupId,
                  class: this.classification,
                });
                // this.fetchData();
                // this.accounts.splice(this.accounts.indexOf(item), 1);
                this.showToast("Account successfully delete", "success");
                this.tableBusy = false;
              })
              .catch((error) => {
                this.tableBusy = false;
                this.showToast(
                  "Something went wrong. Cannot delete account",
                  "error"
                );
              });
          } catch (error) {
            this.tableBusy = false;
            this.showToast(
              "Something went wrong. Cannot delete account",
              "error"
            );
          }
        }
      });
    },
    onSubmitAccount() {
      this.tableBusy = true;
      this.submitted = true;
      this.$v.account.$touch();
      if (this.$v.account.$invalid) {
        return;
      } else {
        // this.accountGroup.fundClassificationId = this.selectedAG;

        if (this.account.id === 0) {
          // console.log(this.account);
          /** Add new Record */
          this.$store
            .dispatch("accounts/createAccounts", this.account)
            .then(() => {
              this.showToast("Account added successfully", "success");
              this.$emit("fetchAccounts", {
                id: this.account.accountGroupId,
                class: this.classification,
              });

              this.modalAccountOptions.show = false;
              this.onAccountReset();
              this.closeAddAccount();

              this.modalAccountOptions.title = "";

              this.submitted = false;
            })
            .catch(() => {
              this.submitted = false;
              this.showToast(
                "Something went wrong. Cannot create record. Please ask your admin for help.",
                "error"
              );
            });
          //   console.log(this.accountGroup);
        } else {
          /** Update Record */
          this.$store
            .dispatch("accounts/updateAccount", {
              id: this.account.id,
              data: this.account,
            })
            .then(() => {
              this.showToast("Account Updated Successfully", "success");
              this.$emit("fetchAccounts", {
                id: this.account.accountGroupId,
                class: this.classification,
              });
              this.modalOptions.show = false;
              this.onAccountReset();
              this.closeAddAccount();
              this.modalOptions.title = "";

              this.tableBusy = false;
              this.submitted = false;
            });
        }
      }
    },
    onAccountReset() {
      this.account = {
        id: 0,
        accountName: null,
        uacs: null,
        uacsSubCode: null,
        coveringPpsas: null,
        accountGroupId: null,
        showInDisbursement: false,
      };
    },
  },
  validations: {
    accountGroup: {
      groupName: { required },
    },
    account: {
      accountName: { required },
      accountGroupId: { required },
    },
  },
};
</script>

<template>
  <div>
    <div class="card">
      <div
        class="card-header d-flex align-items-center justify-content-between"
      >
        <h5 class="card-title mb-0">Account Groups</h5>
        <div>
          <b-button variant="primary" size="sm" @click="addAG">
            <i class="bx bx-plus align-middle me-1"></i>Add Account Group
          </b-button>
        </div>
      </div>
      <div class="card-body px-3 py-2">
        <div v-for="group in accountGroups" :key="group.id">
          <div
            class="font-size-15 text-info cursor-pointer d-flex align-items-center hover-toggle"
            @click="$emit('fetchAccounts', group)"
          >
            <i
              class="bx bx-chevron-right me-1 rotate"
              :class="{
                'rotate-90': group.showDtls,
              }"
            ></i>
            <!-- <span class="badge rounded-pill badge-soft-info">{{ group.rcaCode }}</span> - -->
            {{ group.groupName }}
            <div class="zed-10 ms-1 hover-content">
              <a
                href="javascript:void(0);"
                title="Add New Account"
                @click="addAccount(group)"
                ><i class="mdi mdi-plus text-success"></i
              ></a>
              <a
                href="javascript:void(0);"
                title="Edit"
                @click="updateItem(group)"
                ><i class="mdi mdi-content-save-edit"></i
              ></a>
              <a
                href="javascript:void(0);"
                title="Delete"
                @click="deleteItem(group)"
                ><i class="mdi mdi-trash-can text-danger"></i
              ></a>
            </div>
          </div>
          <!-- Show accounts here... -->
          <div v-if="group.showDtls">
            <div
              v-for="account in group.accounts"
              :key="account.id"
              class="ms-4"
            >
              <div class="d-flex align-items-center hover-toggle">
                <div class="font-size-15 d-flex align-items-center">
                  <span
                    class="badge rounded-pill badge-soft-warning me-1"
                    title="UACS"
                    >{{ account.uacs }}</span
                  >
                  <span
                    class="badge rounded-pill badge-soft-info me-1"
                    title="UACS Subcode"
                    >{{ account.uacsSubCode }}</span
                  >
                  -
                  {{ account.accountName }}
                </div>
                <div class="zed-10 ms-1 hover-content">
                  <a
                    href="javascript:void(0);"
                    title="Edit"
                    @click="updateItemAccount(account)"
                    ><i class="mdi mdi-content-save-edit"></i
                  ></a>
                  <a
                    href="javascript:void(0);"
                    title="Delete"
                    @click="deleteItemAccount(account)"
                    ><i class="mdi mdi-trash-can text-danger"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modals here -->
    <!-- Account Group -->
    <b-modal
      :title="modalOptions.title"
      title-class="font-18"
      no-close-on-backdrop
      v-model="modalOptions.show"
    >
      <div class="mb-3">
        <label for="groupName">Group name</label>
        <b-form-input
          id="groupName"
          v-model="accountGroup.groupName"
          placeholder="Enter Account Group Name..."
          :class="{
            'is-invalid': submitted && $v.accountGroup.groupName.$error,
          }"
        >
        </b-form-input>
        <div
          v-if="submitted && $v.accountGroup.groupName.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.accountGroup.groupName.required"
            >This value is required.</span
          >
        </div>
      </div>
      <!-- <div class="mb-3">
        <label for="groupName">RCA Code</label>
        <b-form-input
          id="groupName"
          v-model="accountGroup.rcaCode"
          placeholder="Enter RCA Code..."
        >
        </b-form-input>
      </div> -->
      <div class="mb-3">
        <label for="fundClassificaton">Fund Classification</label>
        <b-form-select
          class="form-select form-control form-control-sm"
          v-model.number="accountGroup.fundClassificationId"
          size="sm"
          :options="fundClassificationModified"
        >
        </b-form-select>
      </div>
      <div class="mb-3">
        <!-- <div
          class="form-check form-radio-outline form-radio-success mb-3"
          v-for="(type, index) in accountTypeOptions"
          :key="index"
        >
          <input
            class="form-check-input"
            type="radio"
            name="accountType"
            v-model="accountGroup.accountType"
            :value="type"
            :id="index"
          />
          <label class="form-check-label" :for="index"> {{ type }} </label>
        </div> -->
      </div>

      <template #modal-footer>
        <b-button @click="closeAdd" variant="light">
          <i class="ri-close-circle-line align-middle mr-1"></i>
          Cancel
        </b-button>
        <b-form-group>
          <b-button variant="primary" class="float-right" @click="onSubmit">
            <i class="ri-save-3-line align-middle mr-1"></i>
            Save
          </b-button>
        </b-form-group>
      </template>
    </b-modal>
    <!-- Accounts -->
    <b-modal
      :title="modalAccountOptions.title"
      title-class="font-18"
      no-close-on-backdrop
      v-model="modalAccountOptions.show"
    >
      <div class="mb-3">
        <label for="accountName">Account Name</label>
        <b-form-input
          id="accountName"
          v-model="account.accountName"
          placeholder="Enter Account Name..."
          :class="{
            'is-invalid': submitted && $v.account.accountName.$error,
          }"
        >
        </b-form-input>
        <div
          v-if="submitted && $v.account.accountName.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.account.accountName.required"
            >This value is required.</span
          >
        </div>
      </div>
      <div class="form-check form-checkbox-outline form-check-primary mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="customCheckcolor1"
          v-model="account.showInDisbursement"
        />
        <label class="form-check-label" for="customCheckcolor1">
          Display this account in disbursement
        </label>
      </div>
      <div class="mb-3">
        <label for="accountName">UACS</label>
        <b-form-input
          id="accountName"
          v-model="account.uacs"
          placeholder="Enter UACS..."
        >
        </b-form-input>
      </div>
      <div class="mb-3">
        <label for="uacsSubCode">UACS Subcode</label>
        <b-form-input
          id="uacsSubCode"
          v-model="account.uacsSubCode"
          placeholder="Enter UACS Subcode..."
        >
        </b-form-input>
      </div>

      <div class="mb-3">
        <label for="coveringPpsas">Covering PPSAS</label>
        <b-form-input
          id="coveringPpsas"
          v-model="account.coveringPpsas"
          placeholder="Enter Covering PPSAS..."
        >
        </b-form-input>
      </div>

      <div class="mb-3">
        <label for="fundClassificaton">Account Group</label>
        <b-form-select
          class="form-select form-control form-control-sm"
          v-model.number="account.accountGroupId"
          size="sm"
          :options="accountGroupsModified"
          :class="{
            'is-invalid': submitted && $v.account.accountGroupId.$error,
          }"
        ></b-form-select>
        <div
          v-if="submitted && $v.account.accountGroupId.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.account.accountGroupId.required"
            >This value is required.</span
          >
        </div>
      </div>

      <template #modal-footer>
        <b-button @click="closeAddAccount" variant="light">
          <i class="ri-close-circle-line align-middle mr-1"></i>
          Cancel
        </b-button>
        <b-form-group>
          <b-button
            variant="primary"
            class="float-right"
            @click="onSubmitAccount"
          >
            <i class="ri-save-3-line align-middle mr-1"></i>
            Save
          </b-button>
        </b-form-group>
      </template>
    </b-modal>
  </div>
</template>
